//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import iconList from '@/assets/iconfont/iconfont.json'
const originList = iconList.glyphs

export default {
  inheritAttrs: false,
  props: ['current'],
  data() {
    return {
      iconList: originList,
      active: null,
      key: ''
    }
  },
  watch: {
    key(val) {
      if (val) {
        this.iconList = originList.filter(item => item.name.indexOf(val) > -1)
      } else {
        this.iconList = originList
      }
    }
  },
  methods: {
    onOpen() {
      this.active = this.current
      this.key = ''
      this.scrollToActive()
    },
    onClose() {},
    onSelect(icon) {
      this.active = icon
      this.$emit('select', icon)
      this.$emit('update:visible', false)
    },
    scrollToActive() {
      this.$nextTick(() => {
        const $activeItem = this.active
          ? document.getElementsByClassName('active-item')[0]
          : this.$refs.iconWrap.childNodes[0]
        $activeItem && $activeItem.scrollIntoView && $activeItem.scrollIntoView()
      })
    }
  }
}
